export default {
  items: [
    {
      id: 1,
      caption: "Hydrologic Modelling",
      description:
        "Hydrological modelling is the study of water flow on surface and groundwater. It is a simplified version of real world system (Eg. Surface water, ground water, wetland and estuary) that helps in understanding, predicting and managing water resources.Various type of models area used to conceptualize hydrologic model and put relationship between inflow, outflow and storage. These conceptual hydrologic model couple with scenarios to describe specific eventsFlood routing is the technique of determining the flood hydrograph at a section of a river by utilizing the data of flood flow at one or more upstream sections. The hydrologic analysis of problems such as flood forecasting, flood protection, reservoir design and spillway design invariably include flood routing. Flood routing impacts the magnitude of the peak discharge, the time of the peak discharge, depth and extent of flooding",
      // path:"/map",
      // defaultLayer:"NHP_ISRO_Daily_Evapotranspiration_20190105"
    },
    {
      id: 2,
      caption: "Hydrodynamic Modelling",
      description:
        "Stream flow forecast and its inundation simulations prior to the event are an effective and non-structural method of flood damage mitigation. Hydrodynamic Floodsimulation of surface water is one of best approach to calculate the flow pattern and velocity of water in open channel using the Digital Elevation Data, Land Use Land Cover Data, Discharge Information etc. ",
      // path:"/map",
      // defaultLayer:"NHP_ISRO_DSHF_20190105"
    },
  ],
};
